import axios from "../../src/config/axios"

export const merchantsAPI = {
/**
 * Merchants of the campaign.
 * @constructor
 * @param {number} campaignID - The id of the campaign.
 */
	getAdsIds(campaignID) {
		return axios.get(`/api/v3/campaigns/${campaignID}/merchant_ads`).then((resp) => {
			if (!resp.data) {
				throw new Error('error, please refresh or contact support')
			}
			return resp.data;
		})
	},
	getAd(campaignId, adId) {
		return axios.get(`/api/v3/campaigns/${campaignId}/merchant_ads/${adId}`).then((resp) => {
			if (!resp.data) {
				throw new Error('error, please refresh or contact support')
			}
			return resp.data;
		})
	},
	getEmbeddedViews() {
		return axios.get(`/api/v3/embedded_views`).then((resp) => {
			if (!resp.data) {
				throw new Error('error, please refresh or contact support')
			}
			return resp.data;
		})
	},
	getEmbeddedView(embeddedViewId) {
		return axios.get(`/api/v3/embedded_views/${embeddedViewId}`).then((resp) => {
			if (!resp.data) {
				throw new Error('error, please refresh or contact support')
			}
			return resp.data;
		})
	}
};